import { NavLink } from "react-router-dom";
import { useDrag, useDrop } from "react-dnd";
import { ItemTypes } from "./constants";
import FilmanizeCheckbox from "../../../../shared/filmanize-checkbox";
function Prop(props) {
  const {
    prop,
    filmId,
    aliasProp,
    unaliasProp,
    readOnly,
    processingPropIds = [],
    isSelected,
    onToggleSelect
  } = props;

  const hasAliases = (prop.aliases || []).length > 0;
  const isProcessing = processingPropIds.includes(prop.id);

  const propDropped = (alias) => {
    aliasProp(filmId, alias, prop);
  };

  const canDropProp = (item, monitor) => {
    const itemIsProcessing = processingPropIds.includes(item.prop.id);
    return !readOnly && !isProcessing && !itemIsProcessing && item.prop.id != prop.id;
  };

  const canDragProp = (monitor) => {
    return !readOnly && !hasAliases && !isProcessing;
  };

  const [{ isOverProp }, dropProp] = useDrop({
    accept: ItemTypes.PROP,
    drop: (item: any, monitor) => propDropped(item.prop),
    canDrop: (item, monitor) => canDropProp(item, monitor),
    collect: (monitor) => ({
      isOverProp: !!monitor.isOver()
    })
  });

  const [{ isDragging }, drag] = useDrag({
    item: { type: ItemTypes.PROP, prop },
    canDrag: (monitor) => canDragProp(monitor),
    collect: (monitor) => ({
      isDragging: !!monitor.isDragging()
    })
  });

  const getItemStyle = (isDragging) => ({
    background: isDragging ? "#947eed" : "#040f21"
  });

  return (
    <>
      <tr ref={drag}
        style={{
          cursor: !hasAliases && !readOnly && !isProcessing ? "grab" : "",
          opacity: isProcessing ? 0.5 : 1
        }}>
        {!readOnly && (
          <td>
            <FilmanizeCheckbox
              checked={isSelected}
              onChange={onToggleSelect}
            />
          </td>
        )}
        <td ref={dropProp} style={getItemStyle(isOverProp)}>
          {!readOnly && !hasAliases && !isProcessing && (
            <i className="material-icons dark">drag_indicator</i>
          )}
          <NavLink to={`/films/${filmId}/props/${prop.id}/edit`}>
            {prop.name}
          </NavLink>
        </td>
        <td>
          {prop.quantity}
        </td>
        <td>
          {prop.quantityAcquired}
        </td>
        <td>
          {prop.acquisitionMethodDescription}
        </td>
      </tr>
      {(prop.aliases || []).map((alias) => {
        const aliasIsProcessing = processingPropIds.includes(alias.id);
        return (
          <tr key={alias.id} style={{ opacity: aliasIsProcessing ? 0.5 : 1 }}>
            {!readOnly && <td></td>}
            <td colSpan={4}>
              <div style={{ marginLeft: 30 }}>
                {alias.name}
                &nbsp;
                {!readOnly && !aliasIsProcessing && !isProcessing && (
                  <a onClick={() => unaliasProp(filmId, alias, prop)}>
                    <i className="material-icons">cancel</i>
                  </a>
                )}
              </div>
            </td>
          </tr>
        );
      })}
    </>
  );
}

export default Prop;
